import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

// Apply saved text-size preference on boot (before first paint)
(() => {
  try {
    const size = localStorage.getItem('efm-text-size');
    if (size && ['small', 'medium', 'large'].includes(size)) {
      document.documentElement.setAttribute('data-text-size', size);
    } else {
      document.documentElement.setAttribute('data-text-size', 'medium');
    }
  } catch { /* ignore */ }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker only for non-local hosts.
if ('serviceWorker' in navigator) {
  const isLocalHost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

  window.addEventListener('load', () => {
    if (isLocalHost) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister().catch(() => {});
        });
      });
      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name).catch(() => {});
          });
        });
      }
      return;
    }

    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
